<template>
    <VariantItemOption
        :title="option.variantCheckoutData.additionalFeature"
        :subtitle="option.text"
        :package-price="diffPrice"
        :active="active"
        :dense="!!option.marketingHint"
        class="upselling-checkout-option"
    >
        <template #subtitle>
            <div class="align-self-center d-flex mt-1 align-items-center">
                <img
                    v-if="option.marketingHint && option.marketingHint.icon"
                    :src="iconSrc"
                    :alt="option.marketingHint.text"
                    class="marketing-hint__icon mr-3"
                />
                <span>{{ option.text }}</span>
            </div>
        </template>
    </VariantItemOption>
</template>

<script>
import marketingHintIcon from '@/mixins/marketingHintIcon';
import VariantItemOption from '@/components/product/selection/VariantItemOption.vue';
export default {
    name: 'UpsellingCheckout',

    mixins: [marketingHintIcon],

    components: {
        VariantItemOption
    },

    props: {
        option: {
            type: Object,
            required: true
        },

        initialPrice: {
            type: Object,
            required: true
        },

        active: Boolean
    },

    computed: {
        diffPrice() {
            return this.option.price.regularPriceValues.price - this.initialPrice.regularPriceValues.price;
        },

        iconSrc() {
            return this.getIconSrc(this.option.marketingHint.icon);
        }
    }
};
</script>

<style scoped lang="scss">
$background-color: hsl(190, 66%, 41%);

.upselling-checkout-option {
    border-color: $background-color;

    ::v-deep {
        .variant-item__price {
            background-color: $background-color;
        }
    }
}
.marketing-hint__icon {
    filter: invert(45%) sepia(0%) saturate(1%) hue-rotate(63deg) brightness(96%) contrast(98%);
    max-height: 1.7em;
}
</style>
